import { render, staticRenderFns } from "./PageHelp.vue?vue&type=template&id=3d349fe8&scoped=true&"
import script from "./PageHelp.vue?vue&type=script&lang=ts&"
export * from "./PageHelp.vue?vue&type=script&lang=ts&"
import style0 from "./PageHelp.vue?vue&type=style&index=0&id=3d349fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d349fe8",
  null
  
)

export default component.exports